import { Add } from "@mui/icons-material";
import { Box, Button, Stack } from "@mui/material";
import { FC, useState } from "react";
import { useGetPermissionsQuery } from "src/shared/api/rbac/rbac";
import { TablePage } from "src/shared/components/Table";
import { useTableSearchParams } from "src/shared/hooks";
import { Can } from "src/shared/lib/rback/Can";
import { useGetPartnesListQuery } from "../model/api/partners";
import { partnerColumnsList } from "../model/constants";
import { TGetPartnersListQuery } from "../model/types/partner";
import { NewPartnerInitialModal } from "./NewPartnerInitialModal";

export const PartnersList: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { paramsObject, onPaginationModelChange, onSearch } =
    useTableSearchParams<TGetPartnersListQuery>();
  const { search, per_page, page } = paramsObject;
  const rawPage = Number(page);
  const pageNumber = Number.isFinite(rawPage) && rawPage > 0 ? rawPage - 1 : 0;

  const rawPerPage = Number(per_page);
  const pageSize =
    Number.isFinite(rawPerPage) && rawPerPage > 0 ? rawPerPage : 25;

  const { data, isFetching } = useGetPartnesListQuery({
    search,
    page: String(pageNumber + 1),
    per_page: String(pageSize),
  });

  const { data: permissionData } = useGetPermissionsQuery(undefined);

  const allowedAgencies = permissionData?.data?.allowed_agencies || [];

  const filteredRows =
    data?.data?.filter((partner) =>
      allowedAgencies.includes(Number(partner.agency.value)),
    ) || [];

  return (
    <Stack>
      <NewPartnerInitialModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      <Box
        sx={{
          py: 3,
        }}
      >
        <Can perform="partners.create">
          <Button variant="contained" onClick={() => setIsModalOpen(true)}>
            Новый партнер
            <Add />
          </Button>
        </Can>
      </Box>
      <TablePage
        columns={partnerColumnsList}
        rows={filteredRows}
        rowCount={data?.meta.total || 0}
        paginationMode="server"
        tableSearchModel={{
          value: search || "",
          onSearch,
        }}
        paginationModel={{
          page: pageNumber,
          pageSize,
        }}
        onPaginationModelChange={onPaginationModelChange}
        loading={isFetching}
      />
    </Stack>
  );
};
